import { CloseOutlined } from "@ant-design/icons"
import { Button, Flex, Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { EMPTY_FILES_FILTERS, type FilesFilters } from "../types/files-filters.types.ts"

export interface FilterLabelLookup {
  fileTypes: { label: string; value: string }[]
  folders: { label: string; value: string }[]
  albums: { label: string; value: string }[]
}

interface FilesActiveFiltersProps {
  filters: FilesFilters
  labels: FilterLabelLookup
  onChange: (filters: FilesFilters) => void
}

export function FilesActiveFilters({
  filters,
  labels,
  onChange
}: FilesActiveFiltersProps) {
  const { t } = useTranslation()

  const labelFor = (key: keyof FilesFilters, value: string) => {
    if (key === "file_type") {
      return labels.fileTypes.find((o) => o.value === value)?.label ?? value
    }
    if (key === "folder") {
      return labels.folders.find((o) => o.value === value)?.label ?? value
    }
    if (key === "album") {
      return labels.albums.find((o) => o.value === value)?.label ?? value
    }
    return value
  }

  const active = (Object.keys(filters) as Array<keyof FilesFilters>).filter(
    (key) => filters[key]
  )

  if (!active.length) return null

  return (
    <Flex align="center" gap="small" wrap="wrap">
      {active.map((key) => (
        <Tag
          key={key}
          closable
          onClose={() => onChange({ ...filters, [key]: null })}
        >
          {labelFor(key, filters[key] as string)}
        </Tag>
      ))}
      <Button
        type="link"
        size="small"
        icon={<CloseOutlined />}
        onClick={() => onChange(EMPTY_FILES_FILTERS)}
      >
        {t("files.filters.clearAll")}
      </Button>
    </Flex>
  )
}
